var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16671 0.285706C7.54692 0.285706 8.66671 1.4055 8.66671 2.78571C8.66671 4.16591 7.54692 5.28571 6.16671 5.28571C4.7865 5.28571 3.66671 4.16591 3.66671 2.78571C3.66671 1.4055 4.7865 0.285706 6.16671 0.285706Z",
    fill: "#0767FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 10.0903C11.1429 10.6488 10.796 10.9524 9.79175 10.9524H2.20832C1.20409 10.9524 0.857178 10.6488 0.857178 10.0903C0.857178 8.53006 2.84737 6.38094 6.00004 6.38094C9.15878 6.38094 11.1429 8.53006 11.1429 10.0903Z",
    fill: "#0767FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/users-active.233b43f2cf562194e0a213cc950a2543.svg";
export { ForwardRef as ReactComponent };